import { render, staticRenderFns } from "./BaseMoney.vue?vue&type=template&id=150a79b7&"
import script from "./BaseMoney.js?vue&type=script&lang=js&"
export * from "./BaseMoney.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports